import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

export const SIDEBAR_EVENTS = {
  SIDEBAR_GO_TO_CONNECTIONS: {
    ...mixpanel('GUM Sidebar Go To Connections Click'),
    ...traffic2('marketing.sidebar_go_to_connections.click')
  },
  SIDEBAR_GO_TO_AUTOMATIONS: {
    ...mixpanel('GUM Sidebar Go To Automations Click'),
    ...traffic2('marketing.sidebar_go_to_automations.click')
  },
  SIDEBAR_GO_TO_VIEW_PLANS: {
    ...mixpanel('GUM Sidebar Go To View Plans Click'),
    ...traffic2('marketing.sidebar_go_to_view_plans.click')
  },
  SIDEBAR_GO_TO_GET_MORE_CREDITS: {
    ...mixpanel('GUM Sidebar Go To Get More Credits Click'),
    ...traffic2('marketing.sidebar_go_to_get_more_credits.click')
  }
};
